import axios from "axios";

export default {
    getStudyDetail() {
        let id = "541BA5202FA6A499D56885A4F0F0126B";
        if (process.env.NODE_ENV == "development") {
            id = "09F0DF236007BAE6005533CC5901DAD0";
        }
        return axios.get(`/course/Study/getStudyDetail?type=STUDY&id=${id}`);
    },
    getEpisodeDetail(courseId, id) {
        return axios.get(`/course/Study/getEpisodeDetail?courseId=${courseId}&id=${id}`);
    }
}